<template>
  <section
    v-if="showSection"
    class="is-card balance-section"
  >
    <header class="balance-section__header">
      <div class="balance-section__title-row">
        <h2 class="font-md is-bold">
          Limite de consultas
        </h2>

        <InfoCheckCircle
          v-tooltip="'Veja como funciona.'"
          class="balance-section__info"
          @click.native="showHowItWorks = true"
        />
      </div>
      <small class="font-sm balance-section__subtitle">
        Quantas consultas você ainda pode fazer por produto.
      </small>
    </header>

    <HowItWorksModal
      :visible="showHowItWorks"
      @close="showHowItWorks = false"
    />

    <div
      v-if="error"
      class="balance-section__error"
    >
      <p class="font-sm">
        Não foi possível carregar o saldo de consultas.
      </p>
      <button
        class="button is-text"
        @click="fetchBalance"
      >
        Tentar novamente
      </button>
    </div>

    <div
      v-else
      class="balance-section__cards"
    >
      <BalanceCard
        v-for="card in cards"
        :key="card.productId"
        v-bind="card"
      />
    </div>

    <p
      v-if="!error"
      class="font-sm balance-section__footer"
    >
      Seu limite é atualizado conforme suas operações no Prata.
    </p>
  </section>
</template>
<script>
import config from '@/data/config';
import { toast } from '@/utils/message';
import { readBalanceSnapshot, writeBalanceSnapshot } from '@/utils/balanceSnapshot';
import { accountsAPI } from '@/services';

import BalanceCard from '@/components/Hub/BalanceCard.vue';

const PRODUCT_LABELS = {
  [config.PRODUCT_ID_FGTS]: 'FGTS',
  [config.PRODUCT_ID_WORKER_CREDIT]: 'CLT',
};

export default {
  name: 'BalanceSection',
  components: {
    BalanceCard,
    HowItWorksModal: () => import('@/components/Hub/HowItWorksModal.vue'),
    InfoCheckCircle: () => import('@/assets/icons/InfoCheckCircle.vue'),
  },
  data() {
    return {
      queryLimits: null,
      error: false,
      showHowItWorks: false,
    };
  },
  computed: {
    cards() {
      if (!this.queryLimits) return [];

      return Object.entries(PRODUCT_LABELS)
        .filter(([productId]) => this.queryLimits[productId])
        .map(([productId, label]) => {
          const data = this.queryLimits[productId];

          return {
            productId: Number(productId),
            label,
            available: data.available,
            rechargePerSale: data.recharge_per_sale,
          };
        });
    },
    showSection() {
      return this.error || this.cards.length > 0;
    },
  },
  mounted() {
    // Paints with the last known balance (localStorage) before the /me response lands —
    // avoids the card disappearing/reappearing from scratch on every navigation to the Hub.
    const cached = readBalanceSnapshot();
    if (Object.keys(cached).length) {
      this.queryLimits = cached;
    }

    this.fetchBalance();
  },
  methods: {
    async fetchBalance() {
      this.error = false;

      await accountsAPI
        .getInfoUser()
        .then(({ data }) => {
          this.queryLimits = data.query_limits || null;
          // this.notifyRecharges();
        })
        .catch(() => {
          this.error = true;
        });
    },

    // Positive reinforcement (mocked): compares against the snapshot saved in the browser and
    // warns when a product's balance goes UP — recharge on disbursement. It doesn't know the
    // exact reason/amount of the gain from the backend, only the diff between two /me reads.
    notifyRecharges() {
      if (!this.queryLimits) return;

      const previous = readBalanceSnapshot();

      this.cards.forEach(({ productId, label, available }) => {
        const before = previous[productId]?.available;
        if (typeof before === 'number' && available > before) {
          toast(`Boa! Você ganhou +${available - before} consultas de ${label}.`, 'success');
        }
      });

      writeBalanceSnapshot(this.cards);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/src/_textVariables.scss';

.balance-section {
  &__header {
    display: flex;
    flex-direction: column;
  }

  &__title-row {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }

  &__subtitle {
    color: #666666;
    margin-top: 4px;
  }

  &__info {
    width: 20px;
    height: 20px;
    cursor: pointer;
    flex-shrink: 0;
  }

  &__error {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 16px;
  }

  &__cards {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    margin-top: 16px;
  }

  &__footer {
    color: #666666;
    margin-top: 16px;
  }
}
</style>
